export const header = {
    init: () => {
        const $ = jQuery;

        const navToggle = $('#nav-toggle');

        navToggle.on('click', () => {
            $('body').toggleClass('nav-open');
        })
    }
}